import React from 'react';
import * as css from './ROHistoryCardPanelDetailOp.module.scss';
import { strings } from 'src/localization';
import { ROHistory } from 'src/models';
import classNames from 'classnames';
import { THEME } from 'src/constants/ThemeNames';

export interface IProps {
    histIndex: number;
    opIndex: number;
    hidePanel: boolean;
    roHistory: ROHistory[];
    theme: string;
}

const ROHistoryCardPanelDetailOp = (props: IProps) => {
    const panelClass = classNames(
        !props.hidePanel ? css.opPanel : css.opPanelHidden,
        { [css.opPanelAudi]: props.theme === THEME.AUDI },
    );

    const opDescStyles = classNames(
        css.opDesc,
        {
            [css.opDescBMW]: props.theme === 'bmw',
            [css.opDescFord]: props.theme === 'ford',

        },
    );

    const concernLitStyles = classNames(
        css.concernLit,
        {
            [css.concernLitBMW]: props.theme === 'bmw',
            [css.concernLitFord]: props.theme === 'ford',

        },
    );

    const causeLitStyles = classNames(
        css.causeLit,
        {
            [css.causeLitBMW]: props.theme === 'bmw',
            [css.causeLitFord]: props.theme === 'ford',

        },
    );

    const correctionLitStyles = classNames(
        css.correctionLit,
        {
            [css.correctionLitBMW]: props.theme === 'bmw',
            [css.correctionLitFord]: props.theme === 'ford',


        },
    );

    return (
        <div className={panelClass}>
            <div className={opDescStyles}>
                {props.roHistory[props.histIndex].detail[props.opIndex].opDesc}
            </div>
            <div className={css.opPrice}>
                {props.roHistory[props.histIndex].detail[props.opIndex].price}
            </div>
            <div className={concernLitStyles}>
                {strings.Concern}
            </div>
            <div className={css.concern}>
                {props.roHistory[props.histIndex].detail[props.opIndex].concern}
            </div>
            <div className={causeLitStyles}>
                {strings.Cause}
            </div>
            <div className={css.cause}>
                {props.roHistory[props.histIndex].detail[props.opIndex].cause}
            </div>
            <div className={correctionLitStyles}>
                {strings.Correction}
            </div>
            <div className={css.correction}>
                {props.roHistory[props.histIndex].detail[props.opIndex].correction}
            </div>
        </div>
    );
};

export default ROHistoryCardPanelDetailOp;